"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateThirdPartyScriptConfig = exports.updateEmbeddableWidgetConfig = exports.updateCommunityHeaderConfig = exports.updateCommunityFooterConfig = exports.getThirdPartyScriptConfig = exports.getEmbeddableWidgetConfig = exports.getEmbeddableWidgetBundle = exports.getCommunityHeaderConfig = exports.getCommunityFooterConfig = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getCommunityHeaderConfig = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/configuration/getHeader');

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCommunityHeaderConfig() {
    return _ref.apply(this, arguments);
  };
}();

exports.getCommunityHeaderConfig = getCommunityHeaderConfig;

var updateCommunityHeaderConfig = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(header) {
    var res;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/configuration/updateHeader', header);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateCommunityHeaderConfig(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.updateCommunityHeaderConfig = updateCommunityHeaderConfig;

var getCommunityFooterConfig = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var res;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.get('/configuration/getFooter');

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getCommunityFooterConfig() {
    return _ref3.apply(this, arguments);
  };
}();

exports.getCommunityFooterConfig = getCommunityFooterConfig;

var updateCommunityFooterConfig = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(header) {
    var res;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post('/configuration/updateFooter', header);

          case 2:
            res = _context4.sent;
            return _context4.abrupt("return", res.data);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateCommunityFooterConfig(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.updateCommunityFooterConfig = updateCommunityFooterConfig;

var getThirdPartyScriptConfig = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var res;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.get('/settings/thirdPartyScripts/getScripts');

          case 2:
            res = _context5.sent;
            return _context5.abrupt("return", res.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getThirdPartyScriptConfig() {
    return _ref5.apply(this, arguments);
  };
}();

exports.getThirdPartyScriptConfig = getThirdPartyScriptConfig;

var updateThirdPartyScriptConfig = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(scripts) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.post('/settings/thirdPartyScripts/update', scripts);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateThirdPartyScriptConfig(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

exports.updateThirdPartyScriptConfig = updateThirdPartyScriptConfig;

var getEmbeddableWidgetConfig = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
    var res;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _axios.default.get('/settings/conversationalWidget/config');

          case 2:
            res = _context7.sent;
            return _context7.abrupt("return", res.data);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getEmbeddableWidgetConfig() {
    return _ref7.apply(this, arguments);
  };
}();

exports.getEmbeddableWidgetConfig = getEmbeddableWidgetConfig;

var updateEmbeddableWidgetConfig = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(config) {
    var res;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post('/settings/conversationalWidget/config', config);

          case 2:
            res = _context8.sent;
            return _context8.abrupt("return", res.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function updateEmbeddableWidgetConfig(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

exports.updateEmbeddableWidgetConfig = updateEmbeddableWidgetConfig;

var getEmbeddableWidgetBundle = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(config) {
    var res;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.post('/settings/conversationalWidget/bundleContent', config);

          case 2:
            res = _context9.sent;
            return _context9.abrupt("return", res.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getEmbeddableWidgetBundle(_x5) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getEmbeddableWidgetBundle = getEmbeddableWidgetBundle;